import HeatmapChartWidget from './heatmap-chart.widget';
export default HeatmapChartWidget;
